import { render, staticRenderFns } from "./AccionesDisciplinarias.vue?vue&type=template&id=6d3b0ab1&scoped=true"
import script from "./AccionesDisciplinarias.vue?vue&type=script&lang=js"
export * from "./AccionesDisciplinarias.vue?vue&type=script&lang=js"
import style0 from "./AccionesDisciplinarias.vue?vue&type=style&index=0&id=6d3b0ab1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3b0ab1",
  null
  
)

export default component.exports